import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import green from '@material-ui/core/colors/green';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import { RoFormControl, RoFormGroup } from '../RoForm';

import { Label, LabelInner } from './ShortCutSwitch.styles';

const styles = {
  bar: {},
  checked: {
    color: green[500]
  }
};

const ShortCutSwitch = props => {
  const { createShortcut, options, classes, theme, className, blackColor } = props;

  return (
    <RoFormGroup>
      <RoFormControl flex nopadding alpha={1} nobg>
        <FormControlLabel
          className={className}
          control={
            <Switch
              classes={{
                checked: classes.checked
              }}
              checked={options}
              onChange={(e, checked) => createShortcut(checked)}
            />
          }
          label={
            <Label theme={theme}>
              <LabelInner blackColor={blackColor} className={'ro-switch--label'}>
                skrót
              </LabelInner>
            </Label>
          }
        />
      </RoFormControl>
    </RoFormGroup>
  );
};

export default withStyles(styles)(ShortCutSwitch);
